<tour-step-template></tour-step-template>
<mat-sidenav-container class="sidenav-container">
  @if (!hideSideNav()) {
    <mat-sidenav
      #sidenav
      [mode]="sidenavMode()"
      [opened]="sidenavOpened()"
      (openedChange)="onSidenavOpenedChange($event, sidenav)"
      [disableClose]="isDesktop()"
      [class.sidenav-mini]="
        (isDesktop() && !sidenavExpanded()) ||
        (isCompact() && !sidenavService.opened())
      "
      [class.sidenav-expanded]="
        (isDesktop() && sidenavExpanded()) ||
        (isCompact() && sidenavService.opened())
      "
    >
      @if (isMobile() || (isCompact() && sidenavService.opened())) {
        <!-- Mobile or compact drawer opened: show close button -->
        <div class="sidenav-header">
          <h2>Menu</h2>
          <button
            matIconButton
            aria-label="Close Menu"
            (click)="sidenavService.close()"
          >
            <mat-icon>close</mat-icon>
          </button>
        </div>
      } @else if (isDesktop()) {
        <!-- Desktop: show expand/collapse toggle -->
        <div class="sidenav-toggle">
          <button
            mat-icon-button
            tourAnchor="menu.button"
            (click)="toggleSidenavExpanded()"
            [matTooltip]="sidenavExpanded() ? 'Collapse menu' : 'Expand menu'"
          >
            <mat-icon>menu</mat-icon>
          </button>
        </div>
      } @else if (isCompact()) {
        <!-- Compact: show menu button to open drawer -->
        <div class="sidenav-toggle">
          <button
            mat-icon-button
            tourAnchor="menu.button"
            (click)="sidenavService.open()"
            matTooltip="Open menu"
          >
            <mat-icon>menu</mat-icon>
          </button>
        </div>
      }

      <mat-nav-list>
        @if (
          isMobile() ||
          (isDesktop() && sidenavExpanded()) ||
          (isCompact() && sidenavService.opened())
        ) {
          <!-- Full menu (mobile, desktop expanded, or compact drawer opened) -->
          <div matSubheader class="nav-subheader">Create</div>

          <a
            mat-list-item
            routerLink="/create"
            (click)="isMobile() && sidenav.close()"
          >
            <mat-icon matListItemIcon>draw</mat-icon>
            <span matListItemTitle>Create Image</span>
          </a>

          @if (currentUser()) {
            <a
              mat-list-item
              (click)="onCreateVideoClicked()"
              style="cursor: pointer"
            >
              <mat-icon matListItemIcon>movie</mat-icon>
              <span matListItemTitle>Create Video</span>
            </a>

            <a
              mat-list-item
              routerLink="/chats"
              (click)="isMobile() && sidenav.close()"
            >
              <mat-icon matListItemIcon>chat</mat-icon>
              <span matListItemTitle>
                AI Chat
                <app-new-badge></app-new-badge>
              </span>
            </a>

            <div matSubheader class="nav-subheader">Explore</div>

            <a
              mat-list-item
              routerLink="/gallery"
              (click)="isMobile() && sidenav.close()"
            >
              <mat-icon matListItemIcon>photo_library</mat-icon>
              <span matListItemTitle>My Gallery</span>
            </a>

            <a
              mat-list-item
              routerLink="/posts"
              (click)="isMobile() && sidenav.close()"
            >
              <mat-icon matListItemIcon>dynamic_feed</mat-icon>
              <span matListItemTitle>Community Posts</span>
            </a>

            <a
              mat-list-item
              routerLink="/profiles"
              (click)="isMobile() && sidenav.close()"
            >
              <mat-icon matListItemIcon>people</mat-icon>
              <span matListItemTitle>Profiles</span>
            </a>

            <a
              mat-list-item
              routerLink="/ai-model-overview"
              (click)="isMobile() && sidenav.close()"
            >
              <mat-icon matListItemIcon>dashboard</mat-icon>
              <span matListItemTitle>AI Models</span>
            </a>

            @if (featureToggleService.showFeatures(currentUser(), true)) {
              <a
                mat-list-item
                routerLink="/challenges"
                (click)="isMobile() && sidenav.close()"
              >
                <mat-icon matListItemIcon>emoji_events</mat-icon>
                <span matListItemTitle>Challenges</span>
              </a>
            }

            <div matSubheader class="nav-subheader">Account</div>

            <a
              mat-list-item
              routerLink="/payment"
              (click)="isMobile() && sidenav.close()"
            >
              <mat-icon matListItemIcon>payments</mat-icon>
              <span matListItemTitle>Premium Credits</span>
            </a>

            <a
              mat-list-item
              routerLink="/server"
              (click)="isMobile() && sidenav.close()"
            >
              <mat-icon matListItemIcon>cloud</mat-icon>
              <span matListItemTitle>Private Server</span>
            </a>

            <a
              mat-list-item
              routerLink="/settings"
              (click)="isMobile() && sidenav.close()"
            >
              <mat-icon matListItemIcon>settings</mat-icon>
              <span matListItemTitle>Settings</span>
            </a>

            <div matSubheader class="nav-subheader">Help &amp; Resources</div>

            <a mat-list-item routerLink="/tutorial">
              <mat-icon matListItemIcon>school</mat-icon>
              <span matListItemTitle>Tutorial</span>
            </a>

            <a
              mat-list-item
              routerLink="/faq"
              (click)="isMobile() && sidenav.close()"
            >
              <mat-icon matListItemIcon>help</mat-icon>
              <span matListItemTitle>FAQ</span>
            </a>

            <a
              mat-list-item
              routerLink="/updates"
              (click)="isMobile() && sidenav.close()"
            >
              <mat-icon matListItemIcon>campaign</mat-icon>
              <span matListItemTitle>
                What's New
                <app-new-badge></app-new-badge>
              </span>
            </a>

            <a mat-list-item (click)="onDiscord()" style="cursor: pointer">
              <mat-icon
                matListItemIcon
                svgIcon="discord"
                class="social-icon"
              ></mat-icon>
              <span matListItemTitle>Discord</span>
            </a>

            <a mat-list-item href="https://api-doc.aliveai.app" target="_blank">
              <mat-icon matListItemIcon>code</mat-icon>
              <span matListItemTitle>Developer API</span>
            </a>

            <!--            <a mat-list-item href="https://aicharacter.app" target="_blank">-->
            <!--              <mat-icon matListItemIcon>open_in_new</mat-icon>-->
            <!--              <span matListItemTitle>Uncensored AI Chat</span>-->
            <!--            </a>-->

            <a
              mat-list-item
              href="https://stablecharacter.ai?utm_source=aliveai"
              target="_blank"
            >
              <mat-icon matListItemIcon>open_in_new</mat-icon>
              <span matListItemTitle> Train AI Character </span>
            </a>

            <mat-divider class="nav-divider"></mat-divider>

            <a mat-list-item (click)="onLogout()" style="cursor: pointer">
              <mat-icon matListItemIcon>exit_to_app</mat-icon>
              <span matListItemTitle>Logout</span>
            </a>
          } @else {
            <div matSubheader class="nav-subheader">Explore</div>

            <a
              mat-list-item
              routerLink="/posts"
              (click)="isMobile() && sidenav.close()"
            >
              <mat-icon matListItemIcon>dynamic_feed</mat-icon>
              <span matListItemTitle>Community Posts</span>
            </a>

            <a
              mat-list-item
              routerLink="/profiles"
              (click)="isMobile() && sidenav.close()"
            >
              <mat-icon matListItemIcon>people</mat-icon>
              <span matListItemTitle>Profiles</span>
            </a>

            <a
              mat-list-item
              routerLink="/ai-model-overview"
              (click)="isMobile() && sidenav.close()"
            >
              <mat-icon matListItemIcon>dashboard</mat-icon>
              <span matListItemTitle>AI Models</span>
            </a>

            <div matSubheader class="nav-subheader">Account</div>

            <a
              mat-list-item
              routerLink="/login"
              (click)="isMobile() && sidenav.close()"
            >
              <mat-icon matListItemIcon>login</mat-icon>
              <span matListItemTitle>Login</span>
            </a>

            <a
              mat-list-item
              routerLink="/register"
              (click)="isMobile() && sidenav.close()"
            >
              <mat-icon matListItemIcon>person_add</mat-icon>
              <span matListItemTitle>Sign Up</span>
            </a>

            <div matSubheader class="nav-subheader">Resources</div>

            <a mat-list-item href="https://api-doc.aliveai.app" target="_blank">
              <mat-icon matListItemIcon>code</mat-icon>
              <span matListItemTitle>Developer API</span>
            </a>
          }
        } @else {
          <!-- Compact menu (desktop collapsed) - only specific icons -->
          <a
            mat-list-item
            routerLink="/create"
            matTooltip="Create Image"
            matTooltipPosition="right"
            (click)="isMobile() && sidenav.close()"
          >
            <mat-icon>draw</mat-icon>
          </a>

          @if (currentUser()) {
            <a
              mat-list-item
              (click)="onCreateVideoClicked()"
              matTooltip="Create Video"
              matTooltipPosition="right"
              style="cursor: pointer"
            >
              <mat-icon>movie</mat-icon>
            </a>

            <a
              mat-list-item
              routerLink="/chats"
              matTooltip="AI Chat"
              matTooltipPosition="right"
              (click)="isMobile() && sidenav.close()"
            >
              <mat-icon>chat</mat-icon>
            </a>

            <mat-divider class="nav-divider"></mat-divider>

            <a
              mat-list-item
              routerLink="/gallery"
              matTooltip="My Gallery"
              matTooltipPosition="right"
              (click)="isMobile() && sidenav.close()"
            >
              <mat-icon>photo_library</mat-icon>
            </a>

            <a
              mat-list-item
              routerLink="/posts"
              matTooltip="Community Posts"
              matTooltipPosition="right"
              (click)="isMobile() && sidenav.close()"
            >
              <mat-icon>dynamic_feed</mat-icon>
            </a>

            <mat-divider class="nav-divider"></mat-divider>

            <a
              mat-list-item
              routerLink="/payment"
              matTooltip="Premium Credits"
              matTooltipPosition="right"
              class="compact-item"
              (click)="isMobile() && sidenav.close()"
            >
              <mat-icon>payments</mat-icon>
            </a>

            <a
              mat-list-item
              routerLink="/server"
              matTooltip="Private Server"
              matTooltipPosition="right"
              class="compact-item"
              (click)="isMobile() && sidenav.close()"
            >
              <mat-icon>cloud</mat-icon>
            </a>

            <mat-divider class="nav-divider"></mat-divider>

            <a
              mat-list-item
              routerLink="/faq"
              matTooltip="FAQ"
              matTooltipPosition="right"
              class="compact-item"
              (click)="isMobile() && sidenav.close()"
            >
              <mat-icon>help</mat-icon>
            </a>
          } @else {
            <mat-divider class="nav-divider"></mat-divider>

            <a
              mat-list-item
              routerLink="/posts"
              matTooltip="Community Posts"
              matTooltipPosition="right"
              (click)="isMobile() && sidenav.close()"
            >
              <mat-icon>dynamic_feed</mat-icon>
            </a>
          }
        }
      </mat-nav-list>
    </mat-sidenav>
  }

  <mat-sidenav-content>
    @if (currentUser()) {
      @defer {
        <app-toolbar
          [showMenuButton]="isMobile() && !hideSideNav()"
        ></app-toolbar>
      } @placeholder {
        <app-public-toolbar
          [showMenuButton]="isMobile() && !hideSideNav()"
        ></app-public-toolbar>
      }
    } @else {
      <app-public-toolbar
        [showMenuButton]="isMobile() && !hideSideNav()"
      ></app-public-toolbar>
    }
    <div class="main-container">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
